export default {
  default: {
    createButton: 'Create Library',
    tabTitle: 'Files',
    title: 'File Libraries',
  },
}
